import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { store, persistor } from "./ReduxStore/App/store";
import { Provider } from "react-redux";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import "./CSS folder/global.css";
import ThemeProvider from "./Layout/ThemeProvider";
import { PersistGate } from "redux-persist/integration/react";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <ThemeProvider>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </ThemeProvider>
    </Provider>
  </BrowserRouter>
);
